import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Typography,
} from 'transfix-ui/core'
import { CheckOutlineIcon, CloseIcon } from 'transfix-icons'
import { Tag, TAG_SIZE, TAG_STYLE } from 'transfix-ui'
import { ParserTestResult } from '../types'
import { TestResultField } from './TestResultField'

interface IParserTestResultProps {
  parserTestResult: ParserTestResult
}

const useTestResultStyles = makeStyles({
  details: {
    display: 'block',
  },
})

export const TestResult = ({ parserTestResult }: IParserTestResultProps) => {
  const classes = useTestResultStyles()

  return (
    <Accordion>
      <AccordionSummary>
        <Typography>
          {parserTestResult.name}{' '}
          {parserTestResult.passed ? (
            <Tag
              label='Passed'
              icon={<CheckOutlineIcon size='small' />}
              size={TAG_SIZE.small}
              tagStyle={TAG_STYLE.success}
            />
          ) : (
            <Tag
              label='Failed'
              icon={<CloseIcon size='small' />}
              size={TAG_SIZE.small}
              tagStyle={TAG_STYLE.error}
            />
          )}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <TestResultField
          title='Actual Output'
          output={JSON.stringify(parserTestResult.actual_output)}
        />
        <TestResultField
          title='Expected Output'
          output={JSON.stringify(parserTestResult.actual_output)}
        />
        <TestResultField title='Diff' output={JSON.stringify(parserTestResult.diffs)} />
        <TestResultField
          title='Parsed Interchange'
          output={JSON.stringify(parserTestResult.actual_output)}
        />
        <TestResultField title='Notes' output={JSON.stringify(parserTestResult.notes)} />
      </AccordionDetails>
    </Accordion>
  )
}
